
































import {Component, Vue} from "vue-property-decorator";

import Region from "./components/Region.vue";

@Component({
  components: {
    Region
  },
})
export default class ExtranetSetting extends Vue {
  gatewayList=[];
  markerList = [];

  private mounted() {

    this.markerList.push({
      id:1,
      name:'客户1',
      online: 10,
      offline: 2,
      lnglat: '120.45551,31.5942'
    });
    this.markerList.push({
      id:2,
      name:'客户2222222222dddddddddddd22222',
      online: 20,
      offline: 0,
      lnglat: '120.45551,31.5960'
    });

    const mapApiLoaded = document.getElementById('tiandi-map');
    if(mapApiLoaded){
      console.log('地图 api 已加载');
      this.initMap();
    }else{
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.id ='tiandi-map'
      script.async = true;
      script.defer = true;
      script.src = 'http://api.tianditu.gov.cn/api?v=4.0&tk=407fb61fc44bb515e936012cded3a1c3';
      document.body.appendChild(script);
      script.onload = () => {
        console.log('加载天地图');
        this.initMap();
      };
    }

  }

  initMap() {
    const map = new T.Map('mapDiv');
    map.centerAndZoom(new T.LngLat(120.45551,31.5942), 16);

    for (const item of this.markerList) {
      const lantlatArr = item.lnglat.split(',');
      const lnglat = new T.LngLat(lantlatArr[0],lantlatArr[1]);
      const infoWin = new T.InfoWindow('',{
        closeButton: false
      });

      const html = document.getElementById(`id_${item.id}`);
      // const html: any = this.$refs[`infoWin_${item.id}`];
      console.log(html.innerHTML);

      infoWin.setLngLat(lnglat);
      //设置信息窗口要显示的内容
      infoWin.setContent(html.innerHTML);
      //向地图上添加信息窗口
      map.addOverLay(infoWin);
      // console.log(entry); // 1, "string", false
    }

   /* const lnglat = new T.LngLat(120.45551,31.5942);

    //创建信息窗口对象
    const infoWin = new T.InfoWindow('',{
      closeButton: false
    });
    infoWin.setLngLat(lnglat);
    //设置信息窗口要显示的内容
    infoWin.setContent("某某客户,在线10,离线1");
    //向地图上添加信息窗口
    map.addOverLay(infoWin);*/
  }


}



/*export default {
  components:{
    Region
  },
  data() {
    return {
      gatewayList:[]
    };
  },
  mounted() {
    const mapApiLoaded = document.getElementById('tiandi-map');
    if(mapApiLoaded){
      console.log('地图 api 已加载');
      this.initMap();
    }else{
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.id ='tiandi-map'
      script.async = true;
      script.defer = true;
      script.src = 'http://api.tianditu.gov.cn/api?v=4.0&tk=407fb61fc44bb515e936012cded3a1c3';
      document.body.appendChild(script);
      script.onload = () => {
        console.log('加载天地图');
        this.initMap();
      };
    }

  },
  methods: {
    initMap() {
      const map = new T.Map('mapDiv');
      map.centerAndZoom(new T.LngLat(120.45551,31.5942), 16);

      const lnglat = new T.LngLat(120.45551,31.5942);

      //创建信息窗口对象
      const infoWin = new T.InfoWindow('',{
        closeButton: false
      });
      infoWin.setLngLat(lnglat);
      //设置信息窗口要显示的内容
      infoWin.setContent("某某客户,在线10,离线1");
      //向地图上添加信息窗口
      map.addOverLay(infoWin);

      /!*for(let i=0;i<500;i++){
        this.gatewayList.push({code:`G${1}`, lng:120.45551, lat:31.5942});
      }

      const markerList = this.gatewayList.map(item=>{
        //创建标注对象
        return  new T.Marker(new T.LngLat(item.lng,item.lat));
      });
      // map.addOverLay(marker);
      const markerClusterer = new T.MarkerClusterer(map,{
        markers: markerList
      });*!/

    }
  },
};*/

